import { useEffect, useRef } from 'react'
import { trackSearchResultsEvent } from 'analytics/snowplow/events/searchResultsEvents'
import uuidV4 from 'lib/string/uuidV4Utils'
import { AnythingCategory } from 'constants/experience'
import type { ExperienceSearchListState } from './useExperienceSearchList'

export default function useTrackExperienceSearchCombination(
  list: ExperienceSearchListState,
  categoryCodes: Array<number> | undefined,
  enabled: boolean,
) {
  const currentSearch = useRef<{ combination: string, searchId: string, tracked: boolean } | undefined>(undefined)
  const categories = [...new Set(categoryCodes)].filter(Number.isSafeInteger).filter(id => id > 0 && id !== AnythingCategory.id).sort((a, b) => a - b)
  const combination = JSON.stringify({ version: 1, destinationId: list.requestedPlaceId, categoryIds: categories })

  useEffect(() => {
    if (currentSearch.current?.combination !== combination) {
      currentSearch.current = { combination, searchId: uuidV4(), tracked: false }
    }
    if (!enabled) return
    const search = currentSearch.current
    if (list.fetching || list.error || list.isFallbackPlace || !list.placeId || list.placeId !== list.requestedPlaceId ||
      (list.searchId && !list.streamEnded) || !categories.length || !list.ids.length) return

    if (search.tracked) return
    search.tracked = true
    trackSearchResultsEvent({
      searchContext: { vertical: 'experiences', searchId: search.searchId, destinationIds: [list.placeId] },
      filterContexts: [{ type: 'experience_search_combination_v1', label: 'Experience search combination', value: combination }],
    }, list.total ?? list.ids.length)
  }, [enabled, list.fetching, list.error, list.isFallbackPlace, list.placeId, list.requestedPlaceId, list.searchId, list.streamEnded, list.ids.length, list.total, categories.length, combination])
}
